import { Channel } from 'redux-saga';
import { pickBy } from 'lodash';
import ISocketHandler from '../../../api/sockets/ISocketHandler';
import ISocketMessage from '../../../api/sockets/ISocketMessage';
import {
  ADD_MESSAGE_IN_CHAIN,
  UPDATE_MESSAGE_IN_CHAIN,
} from '../../actions/chains';
import { serializeMessage } from '../../serializers/message';
import checkNullableValue from '../../../utils/checkNullableValue';

class ActiveChainEmailChannelHandler implements ISocketHandler {
  socketChannel: Channel<Record<string, unknown>>;

  constructor(channel: Channel<Record<string, unknown>>) {
    this.socketChannel = channel;
  }

  public create(message: ISocketMessage) {
    const { message: rawMessage, persons, attachments } = message.data;
    const messageData = serializeMessage(rawMessage, persons, attachments);

    this.socketChannel.put({
      type: ADD_MESSAGE_IN_CHAIN,
      payload: { message: messageData },
    });
  }

  public delete() {
    return undefined;
  }

  public update(socketMessage: ISocketMessage) {
    if (!socketMessage || !socketMessage.data) return;

    const { message } = socketMessage.data;
    const { message: messageData } = serializeMessage(message);
    const updatedMessageFields = pickBy(messageData, checkNullableValue);

    this.socketChannel.put({
      type: UPDATE_MESSAGE_IN_CHAIN,
      payload: { message: updatedMessageFields },
    });
  }

  public info() {
    return undefined;
  }
}

export default ActiveChainEmailChannelHandler;
